<script>
import { mapState } from "vuex";

export default {
	name: "compBaptisDetail",
	data() {
		return {};
	},

	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatBabtisItem: (state) => state.umatBaptis.item,
		}),
	},
};
</script>

<template>
	<table class="table table-striped table-hover text-left">
		<tbody>
			<tr>
				<td>Nama Baptis</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.nama_baptis }}
				</td>
			</tr>
			<tr>
				<td>No Buku LB</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.no_buku }}
				</td>
			</tr>
			<tr>
				<td>No LB</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.no_lb }}
				</td>
			</tr>
			<tr>
				<td>Tanggal Baptis</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.tanggal_human }}
				</td>
			</tr>

			<tr>
				<td>Imam Pembaptis</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.pembaptis }}
				</td>
			</tr>
			<tr>
				<td>Keuskupan LB</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.keuskupan_lb }}
				</td>
			</tr>
			<tr>
				<td>Paroki LB</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.paroki_lb }}
				</td>
			</tr>
			<tr>
				<td>Nama Wali I</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.wali }}
				</td>
			</tr>
			<tr>
				<td>Nama Wali II</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.wali2 }}
				</td>
			</tr>
			<tr>
				<td>Kriteria Baptis</td>
				<td>:</td>
				<td>
					{{ umatBabtisItem.kriteria }}
				</td>
			</tr>
		</tbody>
	</table>
</template>

